import { render, staticRenderFns } from "./AppImpact.vue?vue&type=template&id=fb91bc6a&"
import script from "./AppImpact.vue?vue&type=script&lang=js&"
export * from "./AppImpact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports